import { Helmet } from "react-helmet-async";

export function Seo({ title, description }) {
  const origin = window.location.origin;
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image" content={`${origin}/og-image.png`} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="NN Mechanic — car repair workshop in Vilnius" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image" content={`${origin}/og-image.png`} />
    </Helmet>
  );
}
